module.exports = __webpack_public_path__ + "static/media/download-invoice-icon.ae125686.svg";